module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "clusters-content"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'locations'
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "country-map-static",
      "src": require("../assets/mills-static.png")
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4682f22d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clusters.vue
// module id = 114
// module chunks = 0